// tslint:disable: max-line-length triple-equals
import Block from 'lqa-ui/lib/Components/Block';
import React, { useEffect, useState } from 'react';
import Icon from 'lqa-ui/lib/Components/Icon';
import {
  getAssessmentAttachments,
  SelfAssessmentSummaryAPI,
} from './../../requests/assessements';
import { Collapse } from 'react-collapse';
import { round, sum } from 'lodash';
import { getItem } from '../../utils/localStorage';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import { StandardPerformaceSelector } from '../../components/commons/StandardPerformanceSelector/standardPerformanceSelector';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import '../../style/main.scss';
import ImageOverlay from 'lqa-ui/lib/Components/ImageOverlay';
import { OverlayAudio } from '../../components/commons/AudioPlayer/OverlayAudio';
import styled from 'styled-components';
import { translateMealPeriodLabel } from '../../enums/labels/MealPeriod';
import DownArrowIcon from '../../components/commons/icons/down_arrow';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { showErrorMessage } from '../../helpers/showMessage';
import { ANNONYMOUS_NAME } from '../../utils/regex';
import { isUnauthorized } from '../../utils/common';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { useTranslation } from 'react-i18next';
import { BottomSheet } from '../../app/common/sharedComponents/BottomSheet';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/GenericStyles.styled';

const AssessmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
  width: 100%;
  .benchmark-block-container {
    padding-left: 10px;
    padding-right: 10px;
  }
  .block.theme-default {
    box-shadow: unset;
  }
`;
const ContentArea = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px;
  padding-bottom: 85px;
`;

const BenchmarkOverallListItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  height: ${({ isOpened }) => (isOpened ? '80px' : '50px')};

  padding: 0 15px 0 20px;
`;

const BenchmarkOverallListItemContent = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  .bol-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .bol-left {
    }
    .bol-right {
      .bol-score-li {
        min-width: 87px;
      }
      .bol-overal-eq {
        min-width: 30px;
      }
      .bol-overal-eq-section {
        min-width: 46px;
        float: left;
      }
    }
  }
`;

const BenchmarkOverallCollapseContent = styled.div`
  .theme-light {
    background: #f6f6f6 !important;
  }
  .theme-lightest {
    background: #ffffff !important;
  }
  .block-limiter {
    padding-bottom: 15px;
    padding-right: 0;
  }
`;

const HotelScoreContainer = styled.div<{ isOpened: boolean }>`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #071c3e;
  display: ${({ isOpened }) => (isOpened ? 'block' : 'none')};
  .hotel-score-label {
    margin-top: 12px;
  }
`;

const DepartmentLabelContainer = styled.div`
  width: 60%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 21px;

  span {
    width: 130px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const DropdownArrowContainer = styled.div<{ expanded: boolean }>`
  transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : '0')};
  transition: all 0.2s;
  margin-left: 10px;
  float: right;
`;

const getEqBgColor = (eqScore) => {
  if (eqScore == 5) {
    return '58C3BB';
  }
  if (eqScore == 4) {
    return 'ABE1DD';
  }
  if (eqScore == 3) {
    return 'F8E58A';
  }
  if (eqScore == 2) {
    return 'F79BA6';
  }
  if (eqScore == 1) {
    return 'CC3044';
  } else {
    return 'white';
  }
};

const labelValue = (value) => {
  switch (value) {
    case 1:
      return '1 Point- Extremely Dissatisfied';
    case 2:
      return '2 Points- Dissatisfied';
    case 3:
      return '3 points- Engaged';
    case 4:
      return '4 Points- Positively Engaged';
    case 5:
      return '5 Points - Completely Engaged';
    default:
      return '';
  }
};

const getEqTextColor = (eqScore) => {
  if (eqScore == 2) {
    return 'white';
  } else {
    return 'black';
  }
};

const SelfAssessmentSummary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loc: any = { ...location };
  const { t } = useTranslation();
  let assessmentDate;
  let assessmentId;
  let duplicateCategories;
  let passsTemplate;
  let selfAssessmentData;
  let selfStayStart;
  let taggedUsers;

  if (loc.state) {
    assessmentDate = loc.state.assessmentDate;
    assessmentId = loc.state.assessmentId;
    duplicateCategories = loc.state.duplicateCategories;
    passsTemplate = loc.state.passsTemplate;
    selfAssessmentData = loc.state.selfAssessmentData;
    selfStayStart = loc.state.selfStayStart;
    taggedUsers = loc.state.taggedUsers;
  }
  const userData = getItem('user');
  const [toggle, setToggle] = useState([false]);
  const [showCom, setShowCom] = useState(false);
  const [showEq, setShowEq] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState(
    getItem('selectedHotel') ? getItem('selectedHotel') : ''
  );
  const [selectedClient, setSelectedClient] = useState(
    getItem('selectedClient') ? getItem('selectedClient') : ''
  );
  const [selectedAssessment, setSelectedAssessment] = useState(assessmentDate);
  const [performanceClassification, setPerformaceClassification] = useState(
    'all'
  );
  const [openPressAndHold, setOpenPressHold] = useState(false);
  const [tempData, setTempData] = useState<{ data: any[] } | undefined>(
    undefined
  );
  const [audioOverlayOpened, setAudioOverlayOpened] = useState(false);
  const [audio, setAudio] = useState<
    | {
        url: string;
        notes: string;
      }[]
    | []
  >([]);

  const [apiData, setApiData] = useState<
    | {
        data: any[];
        overall: any;
      }
    | undefined
  >(undefined);
  const [standard, setStandard] = useState('LQA');
  const [pressHoldData, setPressHoldData] = useState<any>({
    sourceCategoryId: null,
    visit: null,
  });

  const [loader, setLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [eqData, setEqData] = useState<
    | {
        additionalText: string;
        benchmarkTemplateCategoryId: number;
        duplicateCategoryId: number;
        negativeText: string;
        positiveText: string;
        recommendText: string;
        templateCategoryId: number;
        templateEqDescription: string;
        templateEqLabel: string;
        templateEqValue: number;
        visit: number;
        subName: string;
        depCommentary: string;
        time: any;
      }
    | undefined
  >(undefined);
  const [imgAttach, setImgAttach] = useState<
    | {
        templateCategoryId: number;
        url: string;
        notes: string;
      }[]
    | undefined
  >(undefined);
  const [audioAttach, setAudioAttach] = useState<
    | {
        templateCategoryId: number;
        url: string;
        notes: string;
      }[]
    | []
  >([]);
  const alreadyAssignedUsers =
    userData && userData.user && userData.user.id ? [userData.user.id] : [];
  useEffect(() => {
    if (assessmentId) {
      getAssessmentAttachments(assessmentId)
        .then((res) => {
          setImgAttach(res.imageAttachments);
          setAudioAttach(res.audioAttachments);
        })
        .catch((err) => {
          showErrorMessage(
            'Error while getting attachments',
            !isUnauthorized(err)
          );
        });
    }
  }, [assessmentId]);

  useEffect(() => {
    if (selectedAssessment) {
      setLoader(true);
      setApiData(undefined);
      if (assessmentId && standard && performanceClassification) {
        SelfAssessmentSummaryAPI(
          assessmentId,
          standard,
          performanceClassification
        )
          .then((res) => {
            setApiData(res);
            setLoader(false);
          })
          .catch((err) => {
            showErrorMessage(
              'Could not find self assessment data',
              !isUnauthorized(err)
            );
          });
      }
    }
  }, [selectedAssessment, standard, performanceClassification]);

  const handleCollapsible = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!toggle[index]) {
      collapse[index] = true;
    } else {
      if (toggle[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }
    setToggle(collapse);
  };

  const portal = () => {
    if (!eqData) {
      return;
    }

    return (
      <BottomSheet key={'test'} isOpen={open} onClose={() => setOpen(false)}>
        <div className={`${showCom || showEq ? 'pt-190' : 'pt-30'} pb-70`}>
          <Block>
            <div className="text-center">
              <p className="fw-600 f-20 lh-24 color-58C3BB m-0">
                {String(t('COMMON.EI_BEHAVIORAL.EI_BEHAVIORAL_CONNECTION'))}
              </p>
              <span className="fw-400 f-15 lh-16 color-1F1F1F m-0">
                {eqData.time
                  ? moment(eqData.time).format('Do MMM YY  HH:mm')
                  : ''}
              </span>
              <p className="w-335px h-0 black-border-1" />
              <p className="fw-400 f-15 lh-20 color-1F1F1F m-0 mt-20 mb-20">
                <span className="w-40">Primary Emotion</span>{' '}
                <span
                  className={`w-60 p-5 text-left ${
                    eqData.templateEqValue ? '' : 'd-none'
                  }`}
                >
                  <span
                    className={`p-5 h-25px w-130px border-radius-10 lh-25 text-center f-15  ${
                      eqData.templateEqValue
                        ? 'background-' +
                          getEqBgColor(round(eqData.templateEqValue))
                        : 'background-white'
                    }`}
                  >
                    {eqData.templateEqDescription
                      ? `${eqData.templateEqDescription}`
                      : ''}
                  </span>
                </span>
              </p>
              <p className="fw-400 f-15 lh-20 color-1F1F1F m-0 w-80 ml-10p">
                {labelValue(round(eqData.templateEqValue))}
              </p>

              <div className={`p-10 ${showEq ? 'd-block' : 'd-none'}`}>
                {eqData.additionalText && (
                  <>
                    <h5 className="text-left">
                      {String(t('COMMON.EI_BEHAVIORAL.EI_BEHAVIORAL_CONNECTION'))}
                    </h5>
                    <div className="fw-400 f-15 lh-16 color-1F1F1F m-0 text-left">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            eqData && typeof eqData.additionalText === 'string'
                              ? eqData.additionalText.replace(
                                  ANNONYMOUS_NAME,
                                  'employee'
                                )
                              : '',
                        }}
                      />
                    </div>
                  </>
                )}
                {eqData.positiveText && (
                  <>
                    <h5 className="text-left">Positive Aspects</h5>
                    <div className="fw-400 f-15 lh-16 color-1F1F1F m-0 text-left">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            eqData && typeof eqData.positiveText === 'string'
                              ? eqData.positiveText.replace(
                                  ANNONYMOUS_NAME,
                                  'employee'
                                )
                              : '',
                        }}
                      />
                    </div>
                  </>
                )}
                {eqData.negativeText && (
                  <>
                    <h5 className="text-left">Negative Aspects</h5>
                    <div className="fw-400 f-15 lh-16 color-1F1F1F m-0 text-left">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            eqData && typeof eqData.negativeText === 'string'
                              ? eqData.negativeText.replace(
                                  ANNONYMOUS_NAME,
                                  'employee'
                                )
                              : '',
                        }}
                      />
                    </div>
                  </>
                )}
                {eqData.recommendText && (
                  <>
                    <h5 className="text-left">Recommendations</h5>
                    <div className="fw-400 f-15 lh-16 color-1F1F1F m-0 text-left">
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            eqData && typeof eqData.recommendText === 'string'
                              ? eqData.recommendText.replace(
                                  ANNONYMOUS_NAME,
                                  'employee'
                                )
                              : '',
                        }}
                      />
                    </div>
                  </>
                )}
              </div>

              <u
                onClick={() => setShowEq(!showEq)}
                className="fw-400 f-15 lh-16 color-919191 m-0 text-underline"
              >
                {showEq ? 'Collapse' : 'See'} Narrative
              </u>
              <p className="w-335px h-0 black-border-1" />
              {eqData.depCommentary && (
                <>
                  <p className="fw-600 f-20 lh-24 color-58C3BB m-0">
                    Compliancy Summary
                  </p>
                  <span className="fw-400 f-15 lh-16 color-1F1F1F m-0">
                    {eqData.time
                      ? moment(eqData.time).format('DD MMM YY - HH:mm')
                      : ''}
                  </span>
                  <p className="fw-400 f-17 lh-22 color-1F1F1F m-0">
                    {eqData.subName}
                  </p>

                  <div
                    className={`fw-400 f-15 lh-16 color-1F1F1F m-0 text-left ${
                      showCom ? 'd-block' : 'd-none'
                    }`}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: eqData.depCommentary }}
                    />
                  </div>

                  <u
                    onClick={() => setShowCom(!showCom)}
                    className="fw-400 f-15 lh-16 color-919191 m-0 text-underline"
                  >
                    {showCom ? 'Collapse' : 'See'} Narrative
                  </u>
                </>
              )}
            </div>
          </Block>
        </div>
      </BottomSheet>
    );
  };

  return (
    <AssessmentContainer>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.SELF_ASSESSMENT.TITLES.SELF_ASSESSMENT')}
          hasBackButton={true}
        />
      </HeaderContainer>
      {!apiData || loader || !selectedAssessment || !imgAttach ? (
        <ContentArea>
          <div className="box-shadow d-block">
            <Skeleton
              containerClassName="flex-1"
              height={150}
              borderRadius={5}
            />
            <div className="m-10 mb-10">
              <div className="row-separater-skeleton mb-10">
                <Skeleton width={150} height={50} borderRadius={5} />
                <Skeleton width={150} height={50} borderRadius={5} />
              </div>
              <div className="row-separater-skeleton mb-10">
                <Skeleton width={150} height={30} borderRadius={5} />
                <Skeleton width={50} height={25} borderRadius={5} />
              </div>
              <Skeleton
                containerClassName="flex-1"
                height={50}
                borderRadius={5}
                count={5}
              />
            </div>
          </div>
        </ContentArea>
      ) : (
        <ContentArea>
          <div>
            <div className="pt-60 p-20">
              <h1 className="color-black background-none">
                Self Assessment Detail
              </h1>
            </div>
            {portal()}

            <Block innerClassName="benchmark-block-container">
              <StandardPerformaceSelector
                standard={standard}
                setStandard={setStandard}
                selectedHotel={selectedHotel}
                selectedClient={selectedClient}
                selectedAssessment={selectedAssessment}
                performanceClassification={performanceClassification}
                setPerformaceClassification={setPerformaceClassification}
                isSelf={true}
              />
              <div className="f-left">
                <div className="f-left w-60 text-left mt-10">
                  <h3 className="mt-0 f-20 lh-24 fw-600 color-071C3E">
                    Benchmark Overall
                  </h3>
                </div>
                <div className="f-left w-40 text-right mt-10 f-20 lh-24 fw-600 color-071C3E">
                  {round(apiData.overall.score, 1)}%{' '}
                </div>
              </div>
              {apiData.data.map((res, index) => {
                const withEqScores = res.subCategory.filter(
                  (cat) => cat.categoryType === 'subCategory' && cat.eqScore
                );
                const departmentOverallEq = withEqScores.length
                  ? sum(withEqScores.map((s) => s.eqScore)) /
                    withEqScores.length
                  : '';
                return (
                  <>
                    <div className="pt-15">
                      {/* <Block>      */}
                      <BenchmarkOverallListItem isOpened={toggle[index]}>
                        <BenchmarkOverallListItemContent>
                          <div className="bol-content">
                            <div className="bol-left">
                              <h4 className="f-17 lh-22 fw-600 mt-0 mb-0 color-071C3E">
                                {res.name}
                              </h4>
                            </div>
                            <div className="bol-right">
                              <div className="f-left bol-score-li">
                                <b className="f-15 lh-20 fw-600">
                                  {round(res.score, 1)}%
                                </b>
                              </div>
                              {departmentOverallEq ? (
                                <div
                                  className={`bol-overal-eq f-left h-13px w-30px border-radius-7 lh-16 text-center f-12 ml-10 pl-3 pb-6 pr-3 pt-3 ${
                                    'background-' +
                                    getEqBgColor(round(departmentOverallEq))
                                  }`}
                                >
                                  {round(departmentOverallEq, 1).toFixed(1)}
                                </div>
                              ) : (
                                <div className="bol-overal-eq-section" />
                              )}
                              <DropdownArrowContainer
                                onClick={() => handleCollapsible(index)}
                                expanded={toggle[index]}
                              >
                                <DownArrowIcon />
                              </DropdownArrowContainer>
                            </div>
                          </div>
                          <HotelScoreContainer isOpened={toggle[index]}>
                            <div className="f-left w-60 text-left mt-10" />
                            <div
                              className={`f-left w-40 text-center hotel-score-label ${
                                toggle[index] ? 'd-block' : 'd-none'
                              }`}
                            >
                              Hotel % Score
                            </div>
                          </HotelScoreContainer>
                        </BenchmarkOverallListItemContent>
                      </BenchmarkOverallListItem>
                    </div>
                    <div className="alternate-blocks f-none">
                      {res.subCategory.map((subCat, i) => {
                        const subDepartment = duplicateCategories.find(
                          (subCategory) =>
                            subCategory.templateCategoryId === subCat.id
                        );

                        return (
                          <Collapse key={i} isOpened={toggle[index]}>
                            <BenchmarkOverallCollapseContent>
                              <Block
                                theme={i % 2 === 0 ? 'light' : 'lightest'}
                                className="benchmark-card"
                              >
                                <div className="f-left mt-5">
                                  <div className="f-left w-50 text-left">
                                    <a
                                      onClick={() =>
                                        navigate(
                                          '/selfAssessmentSummaryStandards',
                                          {
                                            state: {
                                              apiData,
                                              assessmentId,
                                              standardType: standard,
                                              categoryId: res.id,
                                              subCategoryId: subCat.id,
                                              tempData,
                                              imgAttach,
                                              audioAttach,
                                              performanceClassificationSummary: performanceClassification,
                                              duplicateCategories,
                                              template: passsTemplate,
                                              selfAssessmentData,
                                              selfStayStart,
                                              subDepartmentId: subDepartment.id,
                                              taggedUsers,
                                            },
                                          }
                                        )
                                      }
                                    >
                                      <h5 className="text-underline fw-400 f-15 lh-20 mt-15 mb-10">
                                        {subCat.name}
                                        {(subCat.mealPeriod ||
                                          subCat.outlet) && (
                                          <span
                                            style={{
                                              fontSize: '12px',
                                              fontStyle: 'italic',
                                            }}
                                          >
                                            {'' +
                                              `${
                                                subCat.mealPeriod
                                                  ? ' - ' +
                                                    translateMealPeriodLabel(
                                                      subCat.mealPeriod
                                                    )
                                                  : ''
                                              }${
                                                subCat.outlet
                                                  ? ' - ' + subCat.outlet
                                                  : ''
                                              }`}
                                          </span>
                                        )}
                                      </h5>
                                    </a>
                                  </div>
                                  <div className="f-left w-50 text-center mt-10">
                                    <b className="fw-600 f-15 lh-20">
                                      {round(subCat.score, 1)}%
                                    </b>{' '}
                                  </div>
                                </div>
                                <div className="d-flex clear-both">
                                  <DepartmentLabelContainer>
                                    {subCat.departmentEq && (
                                      <span
                                        className={`${
                                          'background-' +
                                          getEqBgColor(
                                            round(
                                              subCat.departmentEq
                                                .templateEqValue
                                            )
                                          )
                                        } border-radius-10 text-center color-${getEqTextColor(
                                          round(
                                            subCat.departmentEq.templateEqValue
                                          )
                                        )}`}
                                      >
                                        {subCat.departmentEq
                                          ? `${round(
                                              subCat.departmentEq
                                                .templateEqValue,
                                              1
                                            ).toFixed(1)} - ${
                                              subCat.departmentEq
                                                .templateEqDescription
                                            }`
                                          : ''}
                                      </span>
                                    )}
                                  </DepartmentLabelContainer>
                                  <div className="f-right w-50 text-left">
                                    <div
                                      className="mr-22 f-left"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setEqData({
                                          ...subCat.departmentEq,
                                          depCommentary:
                                            subCat.departmentCommentary,
                                          subName: subCat.name,
                                          time:
                                            subCat.dateTimeFormat === 'date'
                                              ? subCat.date
                                              : subCat.dateTime,
                                        });
                                        subCat.departmentEq ||
                                        subCat.departmentCommentary
                                          ? setOpen(true)
                                          : setOpen(false);
                                      }}
                                    >
                                      <Icon
                                        kind={
                                          subCat.departmentEq ||
                                          subCat.departmentCommentary
                                            ? 'commentgreen'
                                            : 'commentgrey'
                                        }
                                        width={25}
                                        height={25}
                                        className="fill-58c3bb"
                                      />
                                    </div>
                                    {audioAttach.filter(
                                      (o) => o.templateCategoryId === subCat.id
                                    ) &&
                                    audioAttach.filter(
                                      (o) => o.templateCategoryId === subCat.id
                                    ).length > 0 ? (
                                      <div
                                        className="mr-22 f-left"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setAudio(
                                            audioAttach
                                              .filter(
                                                (o) =>
                                                  o.templateCategoryId ===
                                                  subCat.id
                                              )
                                              .map((a) => a)
                                          );
                                          setAudioOverlayOpened(true);
                                        }}
                                      >
                                        <Icon
                                          kind="speakergreen"
                                          width={25}
                                          height={25}
                                          className="fill-979797"
                                        />
                                      </div>
                                    ) : (
                                      <div className="mr-22 f-left">
                                        <Icon
                                          kind="speakergrey"
                                          width={25}
                                          height={25}
                                          className="fill-979797"
                                        />
                                      </div>
                                    )}

                                    {imgAttach.filter(
                                      (o) => o.templateCategoryId === subCat.id
                                    ) &&
                                    imgAttach.filter(
                                      (o) => o.templateCategoryId === subCat.id
                                    ).length > 0 ? (
                                      <ImageOverlay
                                        images={imgAttach
                                          .filter(
                                            (o) =>
                                              o.templateCategoryId === subCat.id
                                          )
                                          .map((a) => ({ source: a.url }))}
                                        target={
                                          <div className="f-left mr-22">
                                            {' '}
                                            <Icon
                                              kind="imagegreen"
                                              width={25}
                                              height={25}
                                              className="fill-979797"
                                            />
                                          </div>
                                        }
                                      />
                                    ) : (
                                      <div className="f-left mr-22">
                                        <Icon
                                          kind="imagegrey"
                                          width={25}
                                          height={25}
                                        />
                                      </div>
                                    )}
                                    <div className="f-left">
                                      <Icon
                                        kind="edit-diary"
                                        height={20}
                                        width={20}
                                        onClick={() => {
                                          setPressHoldData(subCat);
                                          setOpenPressHold(true);
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Block>
                            </BenchmarkOverallCollapseContent>
                          </Collapse>
                        );
                      })}
                    </div>
                  </>
                );
              })}
              {audio.length > 0 && (
                <OverlayAudio
                  isOpen={audioOverlayOpened}
                  setOpen={setAudioOverlayOpened}
                  audioUrls={audio}
                  setAudio={setAudio}
                />
              )}
            </Block>
          </div>
        </ContentArea>
      )}
      <BottomSheet
        key={'test'}
        isOpen={openPressAndHold}
        onClose={() => setOpenPressHold(false)}
      >
        <div className="p-20">
          <ButtonLarge
            title="Create Action Plan"
            onClick={() => {
              navigate('/createActionPlan', {
                state: {
                  sourceTemplateCategoryId:
                    pressHoldData.sourceTemplateCategoryId,
                  visit: pressHoldData.visit,
                  selectedAssessment,
                  alreadyAssignedUsers,
                  selfAssessmentId: assessmentId,
                  selfStayStart,
                },
              });
            }}
          />
        </div>
      </BottomSheet>
    </AssessmentContainer>
  );
};

export default SelfAssessmentSummary;
